import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faPlay } from '@fortawesome/free-solid-svg-icons';

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const OneToTenCourseDetails = () => {
    const [course, setCourse] = useState({});
    const [loadding, setLoadding] = useState(true);


    const { id } = useParams();

    useEffect(() => {
        fetch(`https://one0m-backend2.onrender.com/oneToTen/single/${id}`)
            .then(res => res.json())
            .then(data => {
                setCourse(data?.lessonID);
                setLoadding(false);
            })
            .catch(err => {
                setLoadding(true)
            })
    }, [id])

    return (
        <section className='just p-5' style={{ marginTop: '80px' }}>
            {
                loadding ? <>

                    <div class="d-flex justify-content-center">
                        <div class="spinner-grow text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-secondary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-success" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-danger" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-warning" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-dark" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>

                </>

                    :
                    <div className='just-sec'>
                        <div className="subTitle">
                            <h4 className='fw-bold mb-3'>{course?.subject}</h4>
                        </div>
                        <div className="row gy-5">
                            <div className="col-lg-7 col-md-6 col-sm-12 col-12">
                                <div className="etroYoutu">
                                    <iframe width="560" height="415" className='w-100' src={`https://www.youtube.com/embed/${course?.videoNo1}`} title="YouTube video player" frameBorder='1' allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-12 col-12">
                                <div className="lesson-accoordian border">
                                    <div class="accordion accordion-flush" id="accordionFlushExample">
                                        <div class="accordion-item">
                                            <h2 class="accordion-header" id="flush-headingOne">
                                                <button class="accordion-button collapsed fs-4 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                    {course?.videoSubTitle1}
                                                </button>
                                            </h2>
                                            <div id="flush-collapseOne" class="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                <div class="accordion-body fs-5 ms-4" style={{ cursor: 'pointer' }}><FontAwesomeIcon icon={faPlay} className='text-danger' /> {course?.videoMainT1}</div>
                                            </div>
                                        </div>
                                        <div class="accordion-item">
                                            <h2 class="accordion-header" id="flush-headingTwo">
                                                <button class="accordion-button collapsed fs-4 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                                    {course?.videoMainT2}
                                                </button>
                                            </h2>
                                            <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                                <div class="accordion-body ms-4 fs-5" style={{ cursor: 'pointer' }}><FontAwesomeIcon icon={faPlay} className='text-danger' /> {course?.videoSubTitle2}</div>
                                            </div>
                                        </div>
                                        <div class="accordion-item">
                                            <h2 class="accordion-header" id="flush-headingThree">
                                                <button class="accordion-button collapsed fs-4 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                                    {course?.videoMainT3}
                                                </button>
                                            </h2>
                                            <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                                                <div class="accordion-body fs-5 ms-4" style={{ cursor: 'pointer' }}><FontAwesomeIcon icon={faPlay} className='text-danger' /> {course?.videoSubTitle3}</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="phoneCall mt-5">
                                    <h5 className='fs-5 fw-bold'>কোর্সটি সম্পর্কে বিস্তারিত জানতে <span className='text-primary'><FontAwesomeIcon icon={faPhone} /> ফোন করুন (16910)</span></h5>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </section>
    );
};

export default OneToTenCourseDetails;